import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("d2-container", [_c("wlc-breadcrumb"), _c("div", {
    staticClass: "wlc-space-between"
  }, [_c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm,
      size: "small"
    },
    nativeOn: {
      submit: function submit($event) {
        $event.preventDefault();
      }
    }
  }), _c("el-form", {
    attrs: {
      inline: true,
      model: _vm.searchForm
    }
  }, [_c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.addBtn
    }
  }, [_vm._v("新增")])], 1)], 1), _c("el-table", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.tableLoading,
      expression: "tableLoading"
    }],
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "content_zh",
      label: "活动详情（中）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popover", {
          attrs: {
            placement: "bottom-start",
            width: "200",
            trigger: "hover",
            "popper-class": "active-popover",
            title: "#".concat(scope.row.tag.name_zh),
            content: scope.row.content_zh
          }
        }, [_c("div", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_c("div", {
          staticClass: "active-tag"
        }, [_vm._v("#" + _vm._s(scope.row.tag.name_zh))]), _vm._v(" " + _vm._s(scope.row.content_zh) + " ")])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "content_en",
      label: "活动详情（英）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popover", {
          attrs: {
            placement: "bottom-start",
            width: "200",
            trigger: "hover",
            content: scope.row.content_en
          }
        }, [_c("div", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.content_en))])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "content_tw",
      label: "活动详情（繁）"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-popover", {
          attrs: {
            placement: "bottom-start",
            width: "200",
            trigger: "hover",
            content: scope.row.content_tw
          }
        }, [_c("div", {
          attrs: {
            slot: "reference"
          },
          slot: "reference"
        }, [_vm._v(_vm._s(scope.row.content_tw))])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "tag.total_views",
      label: "标签浏览量"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "排序",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-input", {
          attrs: {
            placeholder: "序号",
            type: "number",
            size: "small"
          },
          model: {
            value: scope.row.sort,
            callback: function callback($$v) {
              _vm.$set(scope.row, "sort", $$v);
            },
            expression: "scope.row.sort"
          }
        }, [_c("el-button", {
          attrs: {
            slot: "append"
          },
          on: {
            click: function click($event) {
              return _vm.updateSort(scope.row);
            }
          },
          slot: "append"
        }, [_vm._v("保存")])], 1)];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      prop: "status",
      label: "开放状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(_vm._s(scope.row.status == 2 ? "开放" : "关闭"))];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      fixed: "right",
      label: "操作",
      width: "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.updateDialog(scope.row);
            }
          }
        }, [_vm._v("编 辑")]), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.changeStatus(scope.row);
            }
          }
        }, [_vm._v(_vm._s(scope.row.status === 2 ? "关 闭" : "开 放"))]), _c("el-button", {
          attrs: {
            type: "text"
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(scope.row);
            }
          }
        }, [_vm._v("删 除")])];
      }
    }])
  })], 1), _c("div", {
    staticClass: "wlc-pagination"
  }, [_c("el-pagination", {
    attrs: {
      layout: "total, prev, pager, next",
      "page-size": _vm.searchForm.ps,
      "current-page": _vm.searchForm.pn,
      total: _vm.total
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1), _c("el-dialog", {
    attrs: {
      title: "".concat(_vm.$route.meta.title, "\u7F16\u8F91"),
      width: "30%",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "130px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "活动标签",
      prop: "tag_id"
    }
  }, [_c("el-select", {
    attrs: {
      filterable: "",
      remote: "",
      "reserve-keyword": "",
      placeholder: "请输入关键词",
      "remote-method": _vm.remoteMethod,
      loading: _vm.tagLoading
    },
    model: {
      value: _vm.form.tag_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "tag_id", $$v);
      },
      expression: "form.tag_id"
    }
  }, _vm._l(_vm.tagList, function (item) {
    return _c("el-option", {
      key: item.id,
      attrs: {
        label: item.name,
        value: item.id
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "活动详情（中）",
      prop: "content_zh"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: _vm.form.content_zh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content_zh", $$v);
      },
      expression: "form.content_zh"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "活动详情（英）",
      prop: "content_en"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: _vm.form.content_en,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content_en", $$v);
      },
      expression: "form.content_en"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "活动详情（繁）",
      prop: "content_tw"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 4,
        maxRows: 4
      }
    },
    model: {
      value: _vm.form.content_tw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "content_tw", $$v);
      },
      expression: "form.content_tw"
    }
  })], 1)], 1), _c("div", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };